import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../components/typography/MuiTypography.style";

export const ViewDeliverablesWrapper = styled.div`
  padding: 24px 0px 0px 16px;
  ${responsive.MOBILE`
   padding: 0 16px 0 16px;
   `}
  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}
    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
        }
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }

  .view-locale-link {
    ${h3Regular}
    ${fontWeightBold}
    text-decoration: underline;
    color: ${COLORS.primary_light_blue};
  }

  .deliverable-value {
    max-width: 200px;
  }

  .measurement-double-label {
    padding-bottom: 16px !important;
  }
`;
